import { render, staticRenderFns } from "./usinessPartner.vue?vue&type=template&id=c9dd422a&scoped=true"
import script from "./usinessPartner.vue?vue&type=script&lang=js"
export * from "./usinessPartner.vue?vue&type=script&lang=js"
import style0 from "./usinessPartner.vue?vue&type=style&index=0&id=c9dd422a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9dd422a",
  null
  
)

export default component.exports